/**
 * Quantidade sem casas quando é inteira ("2") e com vírgula quando não é ("1,50"). Usada no
 * extrato e no histórico de visitas do portal, que precisam escrever o número do mesmo jeito.
 */
export const formatQuantity = (value) => {
    const amount = Number(value || 0);
    return Number.isInteger(amount) ? String(amount) : amount.toFixed(2).replace('.', ',');
};
